import { clientPost, clientGet, fetchAndProcessErrors } from '../../utils/fetchwrapper.js';
import { appendQueryParams } from '../../utils/fetchwrapperUtils/appendQueryParams.js';
import { processBody, returnStatus } from '../../utils/fetchwrapperUtils/responseProcessors.js';
import { trustFeedbackUserToken, pickABuyerLocked, trustOpenFeedbackOnItem, trustFeedbackEndpoints, trustTradeExists, trustLeads, trustCreatedTrade } from '../../models/trust/zod.js';

const getTrustFeedbackUserToken = (origin) => clientPost({ url: `${origin}/v1/trust/feedback-api/tokens/user` }).then(processBody(null, trustFeedbackUserToken));
const getPickABuyerLock = (origin, adID) => clientGet({ url: `${origin}/v1/pickabuyer/items/${adID}` }).then(processBody(null, pickABuyerLocked));
const getOpenFeedbackOnItem = (origin, authToken) => fetchAndProcessErrors({
    url: `${origin}/v1/trust/feedback/feedback/search/open-on-item`,
}, {
    headers: { Authorization: `Bearer ${authToken}` },
}).then(processBody(null, trustOpenFeedbackOnItem));
const postTrustFeedback = (origin, feedbackId, feedback, authToken) => fetchAndProcessErrors({
    url: `${origin}/v1/trust/feedback/feedback/${feedbackId}`,
}, {
    method: 'POST',
    body: JSON.stringify(feedback),
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
    },
}).then(returnStatus);
const getTrustFeedbackEndpoints = (origin, authToken) => fetchAndProcessErrors({
    url: `${origin}/v1/trust/feedback`,
}, {
    headers: { Authorization: `Bearer ${authToken}` },
}).then(processBody(null, trustFeedbackEndpoints));
const getTrustTradeExists = (origin, userID, adID, listID, authToken) => fetchAndProcessErrors({
    url: appendQueryParams(`${origin}/v1/trust/feedback/trades/exists`, {
        sellerExternalId: `sdrn:subito:user:${userID}`,
        itemExternalId: `sdrn:subito:classified:${adID}list${listID}`,
    }),
}, {
    headers: { Authorization: `Bearer ${authToken}` },
}).then(processBody(null, trustTradeExists));
const getTrustLeads = (origin, userID, adID, listID, authToken) => fetchAndProcessErrors({
    url: appendQueryParams(`${origin}/v1/trust/feedback/leads`, {
        sellerExternalId: `sdrn:subito:user:${userID}`,
        itemExternalId: `sdrn:subito:classified:${adID}list${listID}`,
    }),
}, {
    headers: { Authorization: `Bearer ${authToken}` },
}).then(processBody(null, trustLeads));
const createTrustTrade = (origin, trade, authToken) => fetchAndProcessErrors({
    url: `${origin}/v1/trust/feedback/trades/user`,
}, {
    method: 'POST',
    body: JSON.stringify(trade),
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
    },
}).then(processBody(null, trustCreatedTrade));

export { createTrustTrade, getOpenFeedbackOnItem, getPickABuyerLock, getTrustFeedbackEndpoints, getTrustFeedbackUserToken, getTrustLeads, getTrustTradeExists, postTrustFeedback };
//# sourceMappingURL=client.js.map
